module.exports = __webpack_public_path__ + "01f43047/img/menu-icon.5f8facae.svg";